      <div class="policy-tracker-header">
        <div class="policy-tracker-header__content">
          <div class="policy-tracker-header__left">
            <div class="policy-tracker-home__icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7V10C2 16 6 20.5 12 22C18 20.5 22 16 22 10V7L12 2Z" fill="white" opacity="0.9"/>
                <path d="M12 6L6 9V12C6 15.31 8.69 18.24 12 19C15.31 18.24 18 15.31 18 12V9L12 6Z" fill="white" opacity="0.7"/>
              </svg>
            </div>
            <div class="policy-tracker-header__text">
              <h1>Renters Insurance Policy</h1>
              <p>{{ policy.policyNumber }}</p>
            </div>
          </div>
          <div class="policy-status-badge">
            <mat-chip class="policy-status-badge__mat-chip" [ngClass]="statusClass">
              {{ statusText }}
            </mat-chip>
          </div>
        </div>